// ForgotPassword.js
import React, { useState } from 'react';
import styles from '../../styles/Auth.module.css';
import { authenticatedFetch } from '../../utils/api';

const ForgotPassword = ({ onClose }) => {
    const [email, setEmail] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setError('');

        try {
            await authenticatedFetch('/api/auth/forgot-password', {
                method: 'POST',
                body: { email }
            });
            setSuccess(true);
        } catch (err) {
            setError(err.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button className={styles.closeButton} onClick={onClose}>&times;</button>

                {!success ? (
                    <>
                        <h2>Reset Password</h2>
                        <p className={styles.modalDescription}>
                            Enter your email address and we'll send you a link to reset your password.
                        </p>

                        {error && <div className={styles.error}>{error}</div>}

                        <form onSubmit={handleSubmit}>
                            <div className={styles.inputGroup}>
                                <label>Email Address</label>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your email"
                                    required
                                    disabled={isSubmitting}
                                />
                            </div>

                            <button
                                type="submit"
                                className={styles.submitButton}
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
                            </button>
                        </form>
                    </>
                ) : (
                    <div className={styles.successMessage}>
                        <h2>Check Your Email</h2>
                        <p>We've sent password reset instructions to {email}</p>
                        <small>Don't forget to check your spam folder!</small>
                    </div>
                )}
            </div>
        </div>
    );
};



export default ForgotPassword;